var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 138,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#menuDown_svg__filter0_d_1022_67562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 97.333a4 4 0 01-2.462 3.693L20 110V12l21.538 8.974A4 4 0 0144 24.667v72.666z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5 97.333a3.5 3.5 0 01-2.154 3.231L20.5 109.25v-96.5l20.846 8.686a3.5 3.5 0 012.154 3.23v72.667z",
    stroke: "#F0F0F0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.485 61.77l-5.578 4.812c-.208.178-.512.017-.512-.271V56.69c0-.288.305-.45.512-.27l5.579 4.81a.367.367 0 01-.001.54z",
    fill: "#29C1B9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "menuDown_svg__filter0_d_1022_67562",
    x: 0,
    y: 0,
    width: 64,
    height: 138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.898039 0 0 0 0 0.898039 0 0 0 0 0.898039 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1022_67562"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1022_67562",
    result: "shape"
  })))));
}
export default SvgMenuDown;